<template>
  <div class="w-100">    
    <multiselect
        v-model="model[schema.model]"
        :options="options"
        :searchable="true"
        :clear-on-select="true"
        :allow-empty="true"
        :placeholder="schema.placeholder || 'Select an option'"
        :multiple="false" 
        @search-change="onSearch"
    ></multiselect>
  </div>
</template>

<script>
import { abstractField } from "vue-form-generator";
import Multiselect from "vue-multiselect";


export default {
  components: { Multiselect },
  mixins: [ abstractField ],
  props: ["model", "schema", "formOptions"],
  data() {
    return {
      options: this.schema.values || [], // Opciones iniciales
    };
  },
  methods: {
    onSearch(searchTerm) {
      // Filtrar dinámicamente si se proporciona `onSearch`
      if (this.schema.onSearch) {
        this.schema.onSearch(searchTerm, (filteredOptions) => {
          this.options = filteredOptions;
        });
      }
    },
  },

};
</script>

<style scoped>
.multiselect {
  width: 100%;
}
.multiselect__placeholder {
  font-style: italic;
}
.multiselect__option--highlight {
  background-color: #d1e8ff;
  color: #333;
}
</style>
